export default __webpack_public_path__ + "static/media/team_s.0516f306.jpg";